import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedComics from './components/FeaturedComics';
import HotRanking from './components/HotRanking';
import LatestUpdates from './components/LatestUpdates';
import FeaturesBanner from './components/FeaturesBanner';
import HomeSEO from './components/HomeSEO';

export default function Home() {
  return (
    <>
      <HomeSEO />
      <main>
        <HeroSection />
        <CategoryGrid />
        <FeaturedComics />
        <HotRanking />
        <LatestUpdates />
        <FeaturesBanner />
      </main>
    </>
  );
}